if (!customElements.get('variant-selects')) {
    class VariantSelect extends HTMLElement {
        constructor() {
            super();

            this.addEventListener('change', this.onVariantChange);

            this.from = this.closest('form');
            this.querySelectorAll('.js-variant-select').forEach(el => {
                if (el.selectedIndex == -1) {
                    el.value = el.querySelector('option:first-child').value;
                }
            })
        }

        onVariantChange(e) {
            this.updateOptions();
            this.updateMasterId();
            this.updateMasterIdMetafileds();
            this.updateVariantStatuses();
            this.updateAddToCart();
            this.hideNotification();

            if (!this.currentVariant) {
            } else {
                this.updateVariantInput();
                if (this.currentVariantMetafields.featured_images != null) {
                    let img = '';
                    this.currentVariantMetafields.featured_images.forEach((el, index)=>{
                       img += `<img src="${el.src}" alt="" srcset="${el.src} 750w" width="${el.width}" height="${el.height}"  class="hp-product-card__img sr-media__img ${this.currentVariantMetafields.featured_images.length>1?index == 0?'  hp-product-card__img--first':'hp-product-card__img--hover':''}" sizes="100vw">`
                    })
                      const parent = this.closest('.hp-product-card');
                    if (parent != null) {
                        const media = parent.querySelector('.hp-product-card__media');
                        if (media != null) {
                            media.innerHTML = img;
                        }
                    }
                }else {
                    if (this.currentVariant.featured_image) {
                        const img = `<img src="${this.currentVariant.featured_image.src}&amp;width=750" alt="" srcset="${this.currentVariant.featured_image.src}&amp;width=375 375w, ${this.currentVariant.featured_image.src}&amp;width=550 550w, ${this.currentVariant.featured_image.src}&amp;width=750 750w" width="${this.currentVariant.featured_image.width}" height="${this.currentVariant.featured_image.height}"  class="hp-product-card__img sr-media__img" sizes="100vw">`
                        const parent = this.closest('.hp-product-card');
                        if (parent != null) {
                            const media = parent.querySelector('.hp-product-card__media');
                            if (media != null) {
                                media.innerHTML = img;
                            }
                        }
                    }
                }
            }
        }

        updateAddToCart() {
            const productForm = this.from;
            if (!productForm) return;
            const addButton = productForm.querySelector('[name="add"]');
            if (!addButton) return;
            if (!this.currentVariant) {
                addButton.classList.add('is-disabled');
            } else {
                if (this.currentVariant.available) {
                    addButton.classList.remove('is-disabled');
                } else {
                    addButton.classList.add('is-disabled');
                }
            }
        }

        hideNotification() {
            const productForm = this.from;
            if (!productForm) return;
            const notification = productForm.querySelector('.slidecart-form-error');
            if (notification != null) {
                notification.remove();
            }
        }

        updateAddToCart() {
            const productForm = this.from;
            if (!productForm) return;
            const addButton = productForm.querySelector('[name="add"]');
            const addButtonText = productForm.querySelector('[name="add"] > span');
            if (!addButton) return;
            if (!this.currentVariant) {
                addButtonText.textContent = theme.productStrings.unavailable;
                addButton.setAttribute('disabled', 'disabled');
            } else {
                if (this.currentVariant.available) {
                    addButtonText.textContent = theme.productStrings.addToCart;
                    addButton.removeAttribute('disabled');
                } else {
                    if (this.currentVariantMetafields.coming_soon == "true") {
                        addButtonText.textContent = theme.productStrings.comingSoon;
                    } else {
                        addButtonText.textContent = theme.productStrings.soldOut;
                    }
                    addButton.setAttribute('disabled', 'disabled');
                }
            }

        }


        updateMasterId() {
            this.currentVariant = this.getVariantData().find((variant) => {
                return !variant.options.map((option, index) => {
                    return this.options[index] === option;
                }).includes(false);
            });
        }

        updateMasterIdMetafileds() {
            if (this.currentVariant) {
                this.currentVariantMetafields = this.getVariantMetafieldsData().find((variant) => {
                    return variant.id == this.currentVariant.id;
                });
            }
        }


        updateVariantInput() {
            const productForm = this.from;
            const input = productForm.querySelector('[name="id"]');
            if (input != null) {
                input.value = this.currentVariant.id;
            }
        }

        updateVariantStatuses() {
            const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
            const inputWrappers = [...this.querySelectorAll('.js-variant-select-input')];
            inputWrappers.forEach((option, index) => {
                if (index === 0) return;
                const optionInputs = [...option.querySelectorAll('option')]
                const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
                const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${index}`] === previousOptionSelected).map(variantOption => variantOption[`option${index + 1}`]);
                // this.setInputAvailability2(optionInputs, availableOptionInputsValue)
            });
        }

        getVariantData() {
            this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"].js-variants').textContent);
            return this.variantData;
        }

        getVariantMetafieldsData() {
            this.variantMetafieldsData = this.variantMetafieldsData || JSON.parse(this.querySelector('[type="application/json"].js-variants-metafields').textContent);
            return this.variantMetafieldsData;
        }

        setInputAvailability2(listOfOptions, listOfAvailableOptions) {
            listOfOptions.forEach(input => {
                if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
                    input.classList.remove('is-unavailable');
                } else {
                    input.classList.add('is-unavailable');
                }
            });
        }

        setInputAvailability(listOfOptions, listOfAvailableOptions) {
            listOfOptions.forEach(input => {
                if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
                    input.classList.remove('disabled');
                } else {
                    input.classList.add('disabled');
                }
            });
            const inputWrappers = [...this.querySelectorAll('.js-variant-select-input')];
            inputWrappers.forEach((option, index) => {
                if (index === 0) return;
                const optionInputs = [...option.querySelectorAll('input[type="radio"]:not(.disabled):checked')];
                if (optionInputs.length == 0) {
                    const optionInputsEnable = [...option.querySelectorAll('input[type="radio"]:not(.disabled)')];
                    if (optionInputsEnable.length > 0) {
                        optionInputsEnable[0].checked = true;
                        optionInputsEnable[0].dispatchEvent(new Event('change', {bubbles: true}));

                    }
                }
            });

        }

        updateOptions() {
            this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
        }


    }

    customElements.define('variant-selects', VariantSelect);
}